import React from "react";
import RouteErrorBoundary from "./RouteErrorBoundary.tsx";

function withRouteErrorBoundary (WrappedComponent: React.ComponentType<any>) {
    return (props: React.ComponentProps<any>) => (
        <RouteErrorBoundary>
            <WrappedComponent {...props} />
        </RouteErrorBoundary>
    )
}


export default withRouteErrorBoundary;
